// extracted by mini-css-extract-plugin
export default {"wrapper":"zgAYV2uRHetC0lmpCR3ZJwBQT6E6YdSW","main":"g74KjtXxTDENRECJpWUEdgC1wJ2VsaZ0","assets":"dDklMTpO_toaBUVc6SUMTgYkM8axokKG","asideContainer":"cMy0OnZEsUqODQPaiJbGAwqZs5226aDx"};